import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface CSATByPage {
  page_id: string;
  page_name: string;
  averageRating: number;
  totalResponses: number;
  csatScore: number; // % de respostas >= 4
}

export const useCSATByPage = (daysRange: number = 30) => {
  return useQuery({
    queryKey: ['csat-by-page', daysRange],
    queryFn: async (): Promise<CSATByPage[]> => {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - daysRange);

      const { data, error } = await supabase
        .from('csat_responses')
        .select('page_id, page_name, rating')
        .gte('created_at', startDate.toISOString());

      if (error) throw error;

      if (!data || data.length === 0) {
        return [];
      }

      // Agrupar por página
      const pageData: Record<string, { ratings: number[]; pageName: string }> = {};

      data.forEach(response => {
        const pageId = response.page_id || 'unknown';
        const pageName = response.page_name || 'Desconhecida';

        if (!pageData[pageId]) {
          pageData[pageId] = {
            ratings: [],
            pageName,
          };
        }

        pageData[pageId].ratings.push(response.rating);
      });

      // Calcular métricas por página
      return Object.entries(pageData)
        .map(([pageId, data]) => {
          const totalResponses = data.ratings.length;
          const averageRating = data.ratings.reduce((sum, r) => sum + r, 0) / totalResponses;
          const satisfiedResponses = data.ratings.filter(r => r >= 4).length;
          const csatScore = (satisfiedResponses / totalResponses) * 100;

          return {
            page_id: pageId,
            page_name: data.pageName,
            averageRating: Math.round(averageRating * 10) / 10,
            totalResponses,
            csatScore: Math.round(csatScore * 10) / 10,
          };
        })
        .sort((a, b) => b.totalResponses - a.totalResponses); // Ordenar por número de respostas
    },
  });
};

